<template>
  <div>
    <!-- Banner Area -->
    <section id="common_banner_one">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="common_banner_text">
              <h2>My Gift List</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Gift List Area -->
    <section id="wedding_list_area" class="ptb-100">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-3 col-lg-3">
            <!-- Nav tabs -->
            <div class="dashboard_tab_button">
              <AccountSidebar></AccountSidebar>
            </div>
          </div>
          <div class="col-sm-12 col-md-9 col-lg-9">
            <div class="dashboard_content">
              <!-- Gift List Details -->
              <div
                v-if="!isLoading && weddingList"
                class="myaccount-content mb-4"
              >
                <div
                  class="d-flex justify-content-between align-items-center mb-4"
                >
                  <h4 class="title">My Gift List</h4>
                  <button class="btn btn-success" @click="shareList">
                    Share List
                  </button>
                </div>

                <!-- Items List -->
                <div class="items-list">
                  <h5 class="mb-3">Gift List Items</h5>
                  <div
                    v-for="item in weddingList.items"
                    :key="item.id"
                    class="card mb-3"
                  >
                    <div class="card-body">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div
                          class="d-flex align-items-center justify-content-start"
                        >
                          <router-link
                            :to="{ path: '/product/' + item.product.id }"
                            class="offcanvas-wishlist-item-image-link"
                          >
                            <img
                              :src="item.product.image"
                              alt="img"
                              class="offcanvas-wishlist-image"
                            />
                          </router-link>
                          <div>
                            <h5>
                              <router-link
                                :to="{ path: '/product/' + item.product.id }"
                                >{{ item.product.name }}</router-link
                              >
                            </h5>
                            <p class="mb-0">
                              Price:
                              {{
                                $country == "eg"
                                  ? (item.product.discount_price_egp > 0
                                      ? item.product.discount_price_egp
                                      : item.product.price_egp) + " EGP"
                                  : "$" +
                                    (item.product.discount_price_usd > 0
                                      ? item.product.discount_price_usd
                                      : item.product.price_usd)
                              }}
                            </p>
                            <p class="mb-0">Status: {{ item.status }}</p>
                            <p
                              v-if="item.status == 'reserved' && item.reserver"
                              class="mb-0"
                            >
                              Reserved by: {{ item.reserver.first_name }}
                              {{ item.reserver.last_name }}
                            </p>
                            <p
                              v-if="
                                item.status == 'purchased' &&
                                item.purchased_by_user
                              "
                              class="mb-0"
                            >
                              Purchased by:
                              {{ item.purchased_by_user.first_name }}
                              {{ item.purchased_by_user.last_name }}
                            </p>
                          </div>
                        </div>

                        <button
                          v-if="item.status === 'available'"
                          class="btn btn-danger"
                          @click="removeItemFromWeddingList(item.id)"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Create List Form (shown only if no list exists) -->
              <!-- <div v-else class="myaccount-content">
                <h4 class="title">Create Gift List</h4>
                <form @submit.prevent="createWeddingList">
                  <div class="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="newList.title"
                      required
                    />
                  </div>
                  <button type="submit" class="btn btn-primary">
                    Create List
                  </button>
                </form>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <Alert ref="alert"></Alert>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Alert from "../components/Alert.vue";
import AccountSidebar from "@/components/account-sidebar.vue";

export default {
  name: "WeddingList",
  components: { AccountSidebar, Alert },
  data() {
    return {
      newList: {
        title: "Gift List",
        description: "",
        wedding_date: null,
      },
      products: [],
      newItem: {
        product_id: null,
        quantity: 1,
      },
    };
  },
  computed: {
    ...mapState({
      weddingList: (state) => state.weddingList.list,
      isLoading: (state) => state.weddingList.isLoading,
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
    this.fetchList();
    if (!this.weddingList) {
      this.createWeddingList();
    }
  },
  methods: {
    ...mapActions("weddingList", [
      "fetchList",
      "createList",
      "addItem",
      "removeItem",
      "getShareUrl",
    ]),
    async createWeddingList() {
      try {
        await this.createList(this.newList);
        this.newList = {
          title: "",
          description: "",
          wedding_date: null,
        };
      } catch (error) {
        console.error("Error creating gift list:", error);
      }
    },
    async addItemToWeddingList() {
      try {
        await this.addItem({
          productId: this.newItem.product_id,
          quantity: this.newItem.quantity,
        });
        this.newItem = {
          product_id: null,
          quantity: 1,
        };
      } catch (error) {
        console.error("Error adding item:", error);
      }
    },
    async removeItemFromWeddingList(itemId) {
      try {
        await this.removeItem(itemId);
      } catch (error) {
        console.error("Error removing item:", error);
      }
    },
    async shareList() {
      try {
        const shareUrl = this.getShareUrl().then((res) => {
          console.log("Share URL:", shareUrl);
          if (!res.data.status.error) {
            // Create a temporary input element
            const tempInput = document.createElement("input");
            tempInput.value = res.data.data.share_url;
            document.body.appendChild(tempInput);

            // Select and copy the text
            tempInput.select();
            document.execCommand("copy");

            // Remove the temporary input
            document.body.removeChild(tempInput);

            // Show success message
            this.$store.dispatch(
              "alert/success",
              "Share link copied to clipboard!",
            );
          }
        });
      } catch (error) {
        this.$store.dispatch("alert/error", "Error getting share URL!");
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
  },
};
</script>

<style scoped>
.card {
  border: 1px solid #ddd;
  border-radius: 4px;
}

.items-list {
  max-height: 400px;
  overflow-y: auto;
}
</style>
